import axios from 'axios';
import { getMetaValue } from './meta';

const MAX_AGE = 31536000;
const IMAGE_CONTENT_TYPE = 'image/*';
const VIDEO_CONTENT_TYPE = 'video/mp4';

axios.defaults.headers.common['X-CSRF-Token'] = getMetaValue('csrf-token');

export const UPLOAD_HEADERS = { 'Content-Type': 'multipart/form-data' };

export const buildFiles = (files, key) => {
  const data = new FormData();
  data.append('kind', key);
  Array.prototype.forEach.call(files, file => data.append('images[]', file));
  return data;
};

const request = (method, ...args) => {
  return new Promise((resolve, reject) => {
    return axios[method](...args)
      .then(response => resolve(response.data))
      .catch(response => reject(response));
  });
};

export const cancel = {
  getMethod(name) {
    return this[name] || (() => {});
  },
  setMethod(name, value) {
    this[name] = value;
    return true;
  },
};

export async function createAttachmentWithPresignedUrl(filename, access = 'public') {
  const response = await axios.post('/api/uploads', { filename, access });
  const { url, format, key } = response.data.upload;
  return {
    presignedUrl: url,
    format,
    key,
  };
}

export function uploadFileToS3(presignedUrl, body, opts = {}) {
  const { contentType, maxAge, onProgress } = opts;

  const headers = {
    'Content-Type': contentType,
    'Cache-Control': `public, max-age=${maxAge || MAX_AGE}`,
  };

  return axios
    .request({
      method: 'PUT',
      url: presignedUrl,
      data: body,
      headers,
      onUploadProgress: p => {
        console.log(p);
        if (onProgress) {
          onProgress(p);
        }
      },
    })
    .then(
      response =>
        response.status === 200
          ? presignedUrl.split('?X')[0]
          : Promise.reject(new Error(`S3 upload failed: ${response.statusText}`)),
    );

  // return fetch(presignedUrl, { headers, body, method: 'PUT' }).then(
  //   response =>
  //     response.ok
  //       ? presignedUrl.split('?X')[0]
  //       : Promise.reject(new Error(`S3 upload failed: ${response.statusText}`)),
  // );
}

export function uploadVideoToS3(presignedUrl, body, opts = {}) {
  const videoOpts = { ...opts, contentType: opts.contentType || VIDEO_CONTENT_TYPE };
  return uploadFileToS3(presignedUrl, body, videoOpts);
}

export function uploadImageToS3(presignedUrl, body, opts = {}) {
  const imageOpts = { ...opts, contentType: opts.contentType || IMAGE_CONTENT_TYPE };
  return uploadFileToS3(presignedUrl, body, imageOpts);
}

export default request;



// WEBPACK FOOTER //
// ./app/javascript/common/utils/request.js